import WelcomeVirtualBox from './WelcomeVirtualBox';

export default WelcomeVirtualBox;
